import React from 'react';
import MaskEdit from '../organisms/MaskEdit';
import { cleanTaxId } from '../../utils/taxIdUtils';

export { cleanTaxId } from '../../utils/taxIdUtils';

interface TaxIdInputProps {
    type: 'PF' | 'PJ';
    value: string;
    onChange: (value: string) => void;
    label?: string;
    required?: boolean;
    errorMessage?: string;
    disabled?: boolean;
}

/**
 * Reusable Tax ID input component.
 * - PF (CPF): mask ___.___.___-__ (digits only)
 * - PJ (CNPJ): mask AA.AAA.AAA/AAAA-__ (alphanumeric + 2 check digits)
 *
 * Emits masked value (with dots/dashes). Use cleanTaxId() before sending to API.
 */
const TaxIdInput: React.FC<TaxIdInputProps> = ({
    type,
    value,
    onChange,
    label,
    required,
    errorMessage,
    disabled,
}) => {
    const isCnpj = type === 'PJ';

    return (
        <MaskEdit
            label={label ?? (isCnpj ? 'CNPJ' : 'CPF')}
            mask={isCnpj ? 'AA.AAA.AAA/AAAA-__' : '___.___.___-__'}
            replacement={isCnpj ? { A: /[A-Za-z0-9]/, _: /\d/ } : { _: /\d/ }}
            style={isCnpj ? { textTransform: 'uppercase' } : undefined}
            value={value}
            onChange={(e) => {
                const raw = e.target.value;
                onChange(isCnpj ? raw.toUpperCase() : raw);
            }}
            required={required}
            errorMessage={errorMessage}
            disabled={disabled}
        />
    );
};

export default TaxIdInput;
